module.exports = __webpack_public_path__ + "img/5.d9ceac62.png";